export default __webpack_public_path__ + "static/media/video.6ccd1e65.svg";